import * as React from 'react';

export const isAppApproaching = ({
  isIOSApproaching = false,
  isAndroidpproaching = false,
}: {
  isIOSApproaching?: boolean;
  isAndroidpproaching?: boolean;
} = {}): boolean => {
  if (typeof window === 'undefined' || !window.flutter_inappwebview) return false;

  const userAgent = navigator.userAgent;

  if (isIOSApproaching) {
    return userAgent.includes('APP_WISHROOM_IOS');
  }

  if (isAndroidpproaching) {
    return userAgent.includes('APP_WISHROOM_ANDROID');
  }

  return userAgent.includes('APP_WISHROOM_IOS') || userAgent.includes('APP_WISHROOM_ANDROID');
};

export const getIsApp = (platform: 'iOS' | 'Android' | 'All' = 'All'): boolean => {
  if (typeof window === 'undefined' || !window.flutter_inappwebview) return false;

  const userAgent = navigator.userAgent;

  if (platform === 'iOS') {
    return userAgent.includes('APP_WISHROOM_IOS');
  }

  if (platform === 'Android') {
    return userAgent.includes('APP_WISHROOM_ANDROID');
  }

  return userAgent.includes('APP_WISHROOM_IOS') || userAgent.includes('APP_WISHROOM_ANDROID');
};

export const useIsApp = (platform: 'iOS' | 'Android' | 'All' = 'All'): boolean => {
  const [isApp, setIsApp] = React.useState<boolean>(false);

  React.useEffect(() => {
    setIsApp(getIsApp(platform));
  }, [platform]);

  return isApp;
};
